import { Navigate, useParams } from "react-router-dom";

type EntityIdRedirectProps = {
  // Builds the new canonical path from the `:id` captured by the old route. Keep the redirect's
  // own <Route path> an exact match (e.g. "/user/edit/:id") — never a wildcard — so a differently
  // shaped old path sharing the same prefix (like Materials' "/user/material/:id") isn't swept
  // up by this component.
  to: (id: string) => string;
};

/**
 * Permanent client-side redirect for a normalised, param-carrying route (e.g. old
 * `/user/:id` -> new `/users/:id`). Old paths are bookmarked and linked from inside the app, so
 * they get a redirect, never a deletion. This is the shared shape Sites/Tags/Materials copy when
 * they normalise their own routes.
 */
const EntityIdRedirect = ({ to }: EntityIdRedirectProps) => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={to(id ?? "")} replace />;
};

export default EntityIdRedirect;
